export default __webpack_public_path__ + "static/media/rmall-project-1.88d78d97.webp";